var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 74,
    viewBox: "0 0 80 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.78l40 52.973L25.81 35.29 0 20.78z",
    fill: "#5CAAF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.81 16.549L11.62 8.397 0 20.78l25.81 14.51V16.548z",
    fill: "#84C4FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.81 16.549h28.38v18.74H25.81V16.55z",
    fill: "#9ED1FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.81 35.29L40 73.752l14.19-38.464H25.81z",
    fill: "#3E9CF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.19 35.29L40 73.752 80 20.78 54.19 35.29z",
    fill: "#5CAAF1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.19 16.549l14.19-8.151L54.19.247H25.81l-14.19 8.15 14.19 8.152h28.38z",
    fill: "#3E9CF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.19 16.549l14.19-8.152L80 20.78 54.19 35.29V16.548z",
    fill: "#84C4FE"
  })));
}

export default __webpack_public_path__ + "./fonts/diamond.46703e524c298c97fb36d30075f448be.svg";
export { SvgDiamond as ReactComponent };